export default __webpack_public_path__ + "static/6815-f31243559e36dab9de1650343d0d292a.jpg";